export default __webpack_public_path__ + "static/assets/med_pill_round_in_L2_solid_x_01_f.4aaa0371.png";